"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
const __theme_1 = __importDefault(require("./_.theme"));
exports.default = {
    icon: (0, css_1.css)({
        color: __theme_1.default.base0A,
    }),
    btn: (0, css_1.css)({
        'margin': 0,
        'width': '100%',
        'color': __theme_1.default.base04,
        'display': 'block',
        'padding': '15px 30px',
        'fontSize': '16px',
        'textAlign': 'left',
        'letterSpacing': '3px',
        ':hover': {
            background: __theme_1.default.base01,
        },
    }),
};
